module.exports = __webpack_public_path__ + "static/img/li_top4_t.f9b28cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/li_top4_t.png
// module id = Z5Zy
// module chunks = 1